<template>
    <el-dialog
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            :append-to-body="appendToBody"
            top="20%"
            width="80%"
            custom-class="registerDialog">

        <div class="container">
            <img :src="icon" class="icon">
            <div class="outer-content">{{outerContent}}</div>
            <div class="main-content">請輸入對方的電話號碼或使用者代碼</div>
            <input v-model="target" class="form-control max-w-260">
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round v-show="isCancel" type="info">{{negativeLabel}}</el-button>
                <el-button @click="confirm" round type="primary">{{positiveLabel}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "RegisterDialog",
        props: {
            icon: {default: require('@/assets/images/member2.svg')},
            outerContent: {default: "提醒"},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "取消"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            isClearTarget: {default: false},
            appendToBody:{default: false},
        },
        data() {
            return {
                showModel: this.value,  //是否顯示 dialog
                target: '',
            }
        },
        created() {

        },
        mounted() {

        },
        watch: {
            value: function () {
                this.showModel = this.value;

                if(this.isClearTarget) {
                  this.target = '';
                }
            }
        },
        methods: {
            cancel: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                // args1 : 是否確定？
                // args2 : 事件類型
                this.$emit('result', false, this.eventType, this.target);
            },
            confirm: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('result', true, this.eventType, this.target);
            }
        }
    }
</script>